import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-sangeeta',
  templateUrl: './sangeeta.component.html',
  styleUrls: ['./sangeeta.component.scss']
})
export class SangeetaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getSangeeta();
  }

}
